import React from 'react';
import { motion } from 'framer-motion';

export const PageHeader = ({ title, subtitle }) => {
  return (
    <div className="container max-w-6xl mx-auto px-6 py-12">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center"
      >
        <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-3">
          {title}
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground">
          {subtitle}
        </p>
      </motion.div>
    </div>
  );
};

export default PageHeader;